module.exports = "<div class=\"ui container\">\n  <div class=\"ui segment\">\n    <h1>404 : page introuvable</h1>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/not-found/not-found.component.html
// module id = 1020
// module chunks = 0